import { render, staticRenderFns } from "./rightDrawer.vue?vue&type=template&id=579f27e4&scoped=true"
import script from "./rightDrawer.vue?vue&type=script&lang=js"
export * from "./rightDrawer.vue?vue&type=script&lang=js"
import style0 from "./rightDrawer.vue?vue&type=style&index=0&id=579f27e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579f27e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579f27e4')) {
      api.createRecord('579f27e4', component.options)
    } else {
      api.reload('579f27e4', component.options)
    }
    module.hot.accept("./rightDrawer.vue?vue&type=template&id=579f27e4&scoped=true", function () {
      api.rerender('579f27e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setting/rightDrawer.vue"
export default component.exports